export interface PrintTicketData {
  id: string | number;
  eventName: string;
  date: string;
  time: string;
  place: string;
  seat: string;
  row: string;
  price: string;
  qrCode?: string;
}

interface PrintTicketProps {
  tickets: PrintTicketData[];
}

const PrintTicket = ({ tickets }: PrintTicketProps) => (
  <div className="w-[210mm] mx-auto bg-white" style={{ padding: '0.5cm', paddingTop: '1cm', paddingBottom: '0.4cm' }}>
    <div className="flex flex-col text-black">
      {tickets.map((ticket, index) => (
        <div
          key={`${ticket.id}-${index}`}
          className="flex flex-col h-[48mm] break-inside-avoid-page print:break-inside-avoid"
        >
          <div className="flex flex-col h-full">
            <div className="grid grid-cols-10">
              <div className="flex min-w-0 flex-col gap-1 col-span-3" style={{ marginLeft: '1cm' }}>
                <h2 className="min-w-0 text-sm font-bold line-clamp-2 break-words">{ticket.eventName}</h2>
                <p className="text-sm">{ticket.place}</p>
                <div className="flex gap-2">
                  <p className="text-sm">{ticket.date}</p>
                  <p className="text-sm">|</p>
                  <p className="text-sm">{ticket.time}</p>
                </div>
                <div className="mt-auto">
                  <p className="font-bold">Sector: {ticket.row}</p>
                  <p className="font-bold break-words">{ticket.seat}</p>
                </div>
              </div>
              <div className="col-span-1"></div>
              <div className="grid grid-cols-10 col-span-6 flex flex-col justify-between">

                <div className="col-span-7 min-w-0">
                  <p className="text-xl font-bold line-clamp-2 break-words">{ticket.eventName}</p>
                </div>

                <div className="col-span-3 flex flex-col justify-end items-end">
                  <img
                    src={ticket.qrCode}
                    alt={`QR code for ${ticket.id}`}
                    className="h-[90px] w-[90px]"
                  />
                </div>

                <div className="flex col-span-6 justify-between items-end">
                  <div className="flex flex-col gap-1">
                    <p className="text-xl font-bold">Sector: {ticket.row}</p>
                    <p className="text-xl font-bold break-words">{ticket.seat}</p>
                  </div>
                </div>

                <div className="flex flex-col col-span-4 items-end justify-end">
                  <p className="text-sm">{ticket.place}</p>
                  <div className="flex gap-2">
                    <p className="text-sm">{ticket.date}</p>
                    <p className="text-sm">|</p>
                    <p className="text-sm">{ticket.time}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default PrintTicket;
